import {useLocation} from '@eitje/bridge'
import {Link} from './link'
import {setModalRouteMetadataInLocalStorage} from '..'

export const ModalLink = ({to, children, disabled, style, className, tabIndex, onClick, t}) => {
	const currentLocation = useLocation()

	// If we're currently in a modal, preserve its background. Ignoring intermediate modal route
	const isCurrentlyInModal = Boolean(currentLocation?.state?.background)
	const newBackgroundLocation = isCurrentlyInModal ? currentLocation.state.background : currentLocation

	const handleNewTabIntent = () => {
		setModalRouteMetadataInLocalStorage({to, backgroundPath: newBackgroundLocation.pathname})
	}

	return (
		<Link
			className={className}
			to={to}
			state={{
				background: newBackgroundLocation,
				modalDepth: (currentLocation?.state?.modalDepth ?? 0) + 1,
			}}
			disabled={disabled}
			style={style}
			tabIndex={tabIndex}
			onClick={onClick}
			t={t}
			onNewTabIntent={handleNewTabIntent}
		>
			{children}
		</Link>
	)
}
